// Core packages
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";

// Core packages
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { DateTimeFormatPipe } from "src/app/shared/pipes/date-format.pipe";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";

import { AuthService } from 'src/app/modules/auth/auth.service';
import { DdtsService } from 'src/app/modules/ddts/ddts.service';
import { RolesService } from 'src/app/modules/roles/roles.service';
import { IUser } from 'src/app/shared/models/user/user.interface';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
  selector: 'app-checklist-detail',
  templateUrl: './checklist-detail.page.html',
  styleUrls: ['./checklist-detail.page.scss']
})
export class ChecklistDetailComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  loggedUserRole: any;
  currentRole: any;
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  loggedUserMaster = false;
  dateTimeFormat: DateTimeFormatPipe;
  activeSection: string; // Active document section
  activeSectionData: any[] = [];
  itemId: string; // Id of active mapping section item
  condoStructure: any;
  documentArchive: any;
  documentArchiveId: string;
  sortedDocuments: any[] = [];
  documentArchiveIsLoading = true;

  fileData: any[] = [];
  moduleData: any[] = [];

  pageTitle = "";
  ddtCode = "";

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private propertiesService: PropertiesService,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private authService: AuthService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    private ddtsService: DdtsService,
    private rolesService: RolesService,
    private helperService: HelperService,
  ) {

  }


  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Page title
    this.pageTitle = this.translateService.instant('ddts.checklistDetailPage.pageTitle');


    // Get logged user data
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe(res => (this.loggedUser = res))
    );
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        res => (this.loggedUserPermissions = res)
      )
    );

    // Get logged user's role data
    this.currentRole = this.loggedUser.userRoles.find((obj: any) => {
      return (
        obj._id.toString() ===
        this.authService.loggedUserRequestedRole$.getValue().toString()
      );
    });
    this.loggedUserRole = this.currentRole.role;
    this.loggedUserMaster =
      this.loggedUserRole.type === "admin" ||
      this.loggedUserRole.type === "operator";
    // this.subscriptions.push(
    //   this.rolesService
    //     .get(this.authService.loggedUserRequestedRole$.getValue())
    //     .subscribe(res2 => {
    //       if (res2.status) {
    //         this.loggedUserRole = res2.role;
    //         this.loggedUserMaster =
    //           this.loggedUserRole.type === "master" ||
    //           this.loggedUserRole.type === "collaborator";
    //       }
    //     })
    // );

    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    const ddtId = this.activatedRoute.snapshot.params.ddtId;

    this.subscriptions.push(
      this.ddtsService
        .getChecklistDetail(ddtId)
        .subscribe(res => {
          if (res.status) {

            if (res.data
              && res.data.ddt
              && res.data.ddt.code) {
              this.pageTitle = `${this.pageTitle} ${res.data.ddt.code}`;
            }

            if (res.data
              && res.data.ddtDocuments
              && Array.isArray(res.data.ddtDocuments)) {
              res.data.ddtDocuments.forEach((item: any) => {
                if (item.files && Array.isArray(item.files)) {
                  item.files.forEach((el: any) => {
                    if (el.status === "missing") {
                      this.fileData.push({
                        property: (item.property && item.property.name) ? item.property.name : "",
                        file: el.name ? el.name : "",
                      });
                    }
                  })
                }
                this.moduleData.push({
                  property: (item.property && item.property.name) ? item.property.name : "",
                  module: item.code,
                })
              });
            }

            this.documentArchiveIsLoading = false;
          } else {
            this.documentArchiveIsLoading = false;
            this.toastrService.error(res.message);
          }
        })
    );
  }

  /**
  * Handle component destroy
  *
  * @since 1.0.0
  */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
